import { Location } from "history";
import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";
import { useLocation } from "react-router-dom";

export interface NavigationData {
  previousPath?: string;
}

const defaultNavigationData: NavigationData = {
  previousPath: undefined,
};

const NavigationContext = createContext<NavigationData>(defaultNavigationData);

export const NavigationProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const location: Location = useLocation();
  const [currentPath, setCurrentPath] = useState<string>(location.pathname);
  const [previousPath, setPreviousPath] = useState<string>();

  useEffect(() => {
    if (location.pathname !== currentPath) {
      setPreviousPath(currentPath);
      setCurrentPath(location.pathname);
    }
  }, [location, currentPath]);

  const contextValue = useMemo(() => ({ previousPath }), [previousPath]);

  return (
    <NavigationContext.Provider value={contextValue}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = (): NavigationData => {
  const context: NavigationData = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error("`useNavigation` must be within a `NavigationProvider`");
  }
  return context;
};
